import { Component, OnInit, ViewChild, Renderer, ElementRef, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import Swal from 'sweetalert2';
import { AccessControlService } from 'src/app/services/access-control.service';
import { AlertService } from '../../services/alert.service';
import { AuthService } from '../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
// declare var $: any;

@Component({
  selector: 'app-add-section',
  templateUrl: './add-section.component.html',
  styleUrls: ['./add-section.component.css']
})
export class AddSectionComponent implements OnInit {
  @ViewChild('addsectionForm') public addsectionForm: NgForm
  model: any = {};
  id: any;
  opt: any;
  buttonTitle: String = '';
  title: String = '';
  sectionModel: any = [];
  static app_id: any;
  application: any = [];
  sectionList: any = [];
  application_name: any;
  breadcrumTitle: string;
  module_id: any;
  currentDisplayNumber:Number=0;
  module:any;
  isSavingData:boolean=false
  constructor(
    private alertService: AlertService,
    private accesscontrolService: AccessControlService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    private toastrService:ToastrService
    ) {
    if (this.router.url.includes('edit-section')) {
      this.id = this.activatedRoute.snapshot.params['id'];
      this.opt = this.activatedRoute.snapshot.params['opt'];
      AddSectionComponent.app_id = this.activatedRoute.snapshot.params['app_id'];
    }
    else {
      AddSectionComponent.app_id = this.activatedRoute.snapshot.queryParamMap.get('app_id');
      this.id = this.activatedRoute.snapshot.queryParamMap.get('id');
      this.module=this.activatedRoute.snapshot.queryParamMap.get('moduleId');
    }

  }
  ngOnInit() {
    if (this.opt == 'edit') {
      this.breadcrumTitle = 'Edit Section'
      this.buttonTitle = 'Update';
      this.getSectionById();
    }
    else {
      this.getModuleNameAndAppNameById()
      this.breadcrumTitle = 'Add Section'
      this.buttonTitle = 'Save'
      // this.getSectionListByModulebyIdDDL()
      this.getNextDisplayNumber();
    }


  }
  submit() {
    if (!this.addsectionForm.valid) {
      return
    }
    if (this.opt == 'edit') {
      this.updateSection();
    }
    else {
      this.pushSection();
    }
  }

  addsection(section: any) {
    this.isSavingData=true
    if (this.model.inherited_from == "none") {
      section[0].inherited_from = null;
      section[0].inherited_name = null;
    }
    this.accesscontrolService.addSection(this.id, section,AddSectionComponent.app_id).subscribe((res) => {
    }, error => {
      this.isSavingData=false
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.toastrService.error(errorMessage)
    }, () => {
      this.isSavingData=false
      this.addsectionForm.resetForm();
      this.toastrService.success("Section Added Successfully");
      this.router.navigate(['section-listing'], { queryParams: { id: this.id, app_id: AddSectionComponent.app_id } ,queryParamsHandling:"preserve"});
    })
  }
  getSectionListByModulebyIdDDL() {
    this.accesscontrolService.getSectionListByModulebyIdDDL(this.id).subscribe((res) => {
      // this.model = res
      this.sectionList = res["section"];
    }, error => {
      console.log(error)
    },
      () => {
      })
  }


  getSectionById() {
    this.accesscontrolService.getSectionById(this.id,AddSectionComponent.app_id).subscribe((res) => {
      this.model = res["0"];
      this.module_id = this.model._id;
      this.sectionList = this.model.section;
      for (var i = 0; i < this.model.section.length; i++) {
        if (this.id == this.model.section[i]._id) {
          this.model.value = this.model.section[i].value;
          this.model.section_name = this.model.section[i].section_name;
          this.model.section_display_name = this.model.section[i].section_display_name;
          this.model.section_description = this.model.section[i].section_description;
          this.model.inherited_from = this.model.section[i].inherited_from;
          this.model.inherited_name = this.model.section[i].inherited_name;
          this.model.display_order = this.model.section[i].display_order;
        }
      }
    }, error => {
      console.log(error)
    },
      () => {
      })
  }
  pushSection() {
    var section: any = []
    if (!this.addsectionForm.valid) {
      return
    }
    section.push(
      {
        value: false,
        section_name: this.model.section_name,
        section_display_name: this.model.section_display_name,
        section_description: this.model.section_description,
        inherited_from: this.model.inherited_from,
        inherited_name: this.model.inherited_name,
        display_order: this.model.display_order,
      });
    this.addsection(section);
  }

  updateSection() {
    this.isSavingData=true
    if (this.model.inherited_from == "none") {
      this.model.inherited_from = null;
      this.model.inherited_name = null;
    }
    this.model.section_id = this.id
    this.accesscontrolService.updateSection(this.model).subscribe((res) => {
    }, error => {
      this.isSavingData=false
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.toastrService.error(errorMessage)
    }, () => {
      this.isSavingData=false
      this.addsectionForm.resetForm();
      this.toastrService.success("Section updated Successfully");
      this.router.navigate(['section-listing'], { queryParams: { id: this.module_id, app_id: AddSectionComponent.app_id } ,queryParamsHandling:"preserve"});
    })
  }

  getModuleNameAndAppNameById() {
    this.accesscontrolService.getModuleNameAndAppNameById(this.id).subscribe((res) => {
      debugger;
      this.model = res;
      this.sectionList = res["section"];
      if(this.currentDisplayNumber>0)
      this.addsectionForm.controls.display_order.patchValue(this.currentDisplayNumber);
    }, error => {
      console.log(error)
    },
      () => {
      })
  }
  cancel() {
    if (this.opt == 'edit') {
      this.router.navigate(['section-listing'], { queryParams: { id: this.module_id, app_id: AddSectionComponent.app_id },queryParamsHandling:"preserve" });
    }
    else {
      this.router.navigate(['section-listing'], { queryParams: { id: this.id, app_id: AddSectionComponent.app_id },queryParamsHandling:"preserve" });
    }
  }
  getinheritedSectionName(section_id: any) {
    if (section_id == "none") {
      return
    }
    else {
      if (this.model && this.model.section) {
        for (var i = 0; i < this.model.section.length; i++) {
          if (section_id == this.model.section[i]._id) {
            this.model.inherited_name = this.model.section[i].section_display_name
          }
        }
      }
    }
  }
  backToSystemModules() {
    if (AddSectionComponent.app_id) {
      this.router.navigate(['/edit-module-listing/' + AddSectionComponent.app_id],{queryParamsHandling:"preserve"});
    }
  }
  getNextDisplayNumber() {
    this.accesscontrolService.getNextDisplayNumber({
      appId: AddSectionComponent.app_id,
      moduleId: this.id,
      type: 'section',
      sectionId:null
    }).subscribe((res: any) => {
      if (this.id)
      this.currentDisplayNumber=res.data;
      this.addsectionForm.controls.display_order.patchValue(this.currentDisplayNumber);
    },
      error => {

      })
  }
}
